var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1028 0.750013C9.75506 0.74891 9.41058 0.816908 9.08934 0.950058C8.76811 1.08321 8.47653 1.27886 8.23155 1.52564L0.972173 8.78439C0.879056 8.87765 0.817805 8.99797 0.797173 9.12814L0.257798 12.5269C0.242249 12.6244 0.250024 12.7242 0.280488 12.8181C0.310952 12.9121 0.363236 12.9974 0.433058 13.0673C0.50288 13.1371 0.588252 13.1894 0.682178 13.2198C0.776105 13.2503 0.875912 13.2581 0.973423 13.2425L4.3753 12.7031C4.50547 12.6825 4.62578 12.6213 4.71905 12.5281L11.9747 5.26876C12.3448 4.89828 12.5968 4.42635 12.6987 3.91265C12.8006 3.39895 12.7479 2.86657 12.5471 2.38285C12.3464 1.89913 12.0068 1.4858 11.5711 1.19515C11.1354 0.904506 10.6234 0.749594 10.0997 0.750013H10.1028ZM3.9753 11.5L1.6253 11.875L2.0003 9.52689L7.24405 4.28251L9.2203 6.25876L3.9753 11.5ZM11.0909 4.38501L10.1034 5.37501L8.1253 3.39689L9.11342 2.40939C9.37955 2.15535 9.73332 2.01361 10.1012 2.01361C10.4691 2.01361 10.8229 2.15535 11.089 2.40939C11.2189 2.53906 11.3218 2.69305 11.3921 2.86254C11.4624 3.03204 11.4985 3.21372 11.4985 3.3972C11.4985 3.58068 11.4624 3.76236 11.3921 3.93186C11.3218 4.10135 11.2189 4.25534 11.089 4.38501H11.0909Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditor);
export default __webpack_public_path__ + "static/media/editor.c196e5252761202276693e8eab643594.svg";
export { ForwardRef as ReactComponent };